"use client";

import { useMutation } from "@tanstack/react-query";
import { Auth } from "@/api/auth";
import { clearPendingVerification } from "@/views/sign-up/pending-verification";

export interface LoginFormValues {
  email: string;
  password: string;
}

export const useLoginMutation = () =>
  useMutation({
    mutationFn: ({ email, password }: LoginFormValues) => Auth.login(email, password),
    onSuccess: (_response, values) => {
      clearPendingVerification(values.email);
      window.location.replace("/estates");
    },
  });
